module.exports = __webpack_public_path__ + "static/gallery7-d2881d6d4a34d0d9b4eefa183b38f57e.jpg";